<template>
  <el-row id="viewCoursewares">
    <el-col class="h-full w-260px mr-20px">
      <ul class="h-full courseware">
        <li v-for="item in coursewareList" :key="item.id" class="w-249px h-150px">
          <div class="flex leading-22px justify-between">
            <span>{{ item.name }}</span>
            <span>{{ item.statusName }}</span>
          </div>
          <question-view-image
            class="w-full h-full picture-wrap"
            v-if="item.cover"
            :imgStr="item.cover"
            :setStyle="{
              maxHeight: '100%',
              objectFit: 'cover',
              maxWidth: '100%',
              margin: '0 auto',
            }"
          ></question-view-image>
        </li>
      </ul>
    </el-col>
    <el-col class="h-full position-relative right-wrap">
      <div>
        <p class="card_title">课程信息</p>
        <div class="">
          <el-form :model="lessonForm" label-position="right" label-width="100px">
            <el-row>
              <el-col :span="12">
                <el-form-item label="培训名称:">{{ lessonForm.name }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="培训类型:">{{ lessonForm.trainingTypeName }}</el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="截止时间:"
                  >{{ lessonForm.trainingDateEnd | showContent('time') }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="关联考试计划:">
                  {{ lessonForm.examName || '' }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="合格学分:">{{ lessonForm.qualifiedCredits }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="合格学时(h):">
                  {{ showText(lessonForm.qualifiedCreditHours) }}</el-form-item
                >
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="培训公告:">{{ lessonForm.notice }}</el-form-item>
              </el-col>
            </el-row>
            <div class="">
              我的培训记录:
              <div class="flex-1 mt-10px pl-30px">
                <div class="mb-10px">
                  <span class="mr-20px"
                    >课程学习进度：{{
                      (lessonForm.finishCoursewares || 0) + ' / ' + lessonForm.coursewareCount
                    }}</span
                  >
                  <span class="mr-20px"
                    >学时完成进度：{{
                      getPercent(lessonForm.finishTimes, lessonForm.coursewareTimes)
                    }}</span
                  >
                  <span
                    >学分完成进度：{{
                      (lessonForm.finishCredits || 0) + ' / ' + lessonForm.coursewareCredits
                    }}</span
                  >
                </div>
                <div>
                  <el-table :data="coursewareList" border class="w-full" stripe>
                    <el-table-column
                      label="课件"
                      prop="name"
                      show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column label="是否必修" prop="isCompulsory" show-overflow-tooltip>
                      <template slot-scope="scope">
                        <span>{{ scope.row.isCompulsory ? '是' : '否' }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="节点"
                      prop="nodes"
                      show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                      label="学习开始时间"
                      prop="studyTimeStart"
                      show-overflow-tooltip
                    >
                      <template slot-scope="scope">
                        <span>{{ scope.row.studyTimeStart | showContent('time') }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="学习结束时间" prop="studyTimeEnd" show-overflow-tooltip>
                      <template slot-scope="scope">
                        <span>{{ scope.row.studyTimeEnd | showContent('time') }}</span>
                      </template></el-table-column
                    >
                    <el-table-column
                      label="学习情况"
                      prop="statusName"
                      show-overflow-tooltip
                    ></el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </el-form>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { TrainingTaskApi } from '@wiz-api/training-management'
import dayjs from 'dayjs'

import QuestionViewImage from '../QuestionViewImage'
import { formatSeconds } from '../EnumField'

const trainingTaskApi = new TrainingTaskApi()

export default {
  props: {
    data: {
      type: Object,
      default() {
        return {}
      },
    },
    trainId: {
      typeof: String,
      default: '',
    },
  },
  filters: {
    showContent: (val, type) => {
      let result = ''
      if (type === 'time') {
        result = val && dayjs(val).format('YYYY-MM-DD')
      }
      return result
    },
  },
  components: { QuestionViewImage },
  data() {
    return {
      lessonForm: {},
      coursewareList: [],
    }
  },
  computed: {},
  methods: {
    showText(val) {
      if (typeof val !== 'number') return ''
      return formatSeconds(val)
    },
    /**
     * @function 获取课件信息
     */
    async getCoursewareInfo() {
      const [err, res] = await trainingTaskApi.getTask({ id: this.trainId })
      if (err) return
      this.coursewareList = res.coursewares
      this.lessonForm = res
    },
    getPercent(molecule = 0, denominator = 0) {
      const val = `${this.showText(molecule)} / ${this.showText(denominator)}`
      return val
    },
  },
  created() {
    this.getCoursewareInfo()
  },
  mounted() {},
}
</script>

<style scoped lang="scss">
#viewCoursewares {
  ::v-deep .el-form-item {
    margin-bottom: 0px;
  }
  .right-wrap {
    width: calc(100% - 290px);
  }
  .courseware {
    li {
      border: 1px solid #dce0e7;
      margin-bottom: 5px;
      overflow: hidden;
      position: relative;
      padding: 2px;
      padding-top: 0px;
      cursor: pointer;
      &:hover {
        border-color: #1890ff !important;
      }
      &:last-child {
        margin-bottom: 0px;
      }
      .picture-wrap {
        height: 126px;
        width: 100%;
        img {
          object-fit: cover;
          height: 100% !important;
          width: 100%;
        }
      }
    }
  }
}
</style>
